import React from 'react';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import RenderImg from '@/pages/opinion/components/RenderImg';
import AIGeneratedTag from '@op/components/AIGeneratedTag';
import { transLanguage } from '@op/utils';
import moment from 'moment';
import { reviewsMaxZeroFormat } from '@op/utils/value';
import { Bubble, Icon } from 'tea-component';
import { LanguageType } from '@op/types/common';
import ChannelLabel from '@op/components/ChannelLabel';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { sentimentIconMap } from '@op/constants';
import useSentimentValue from '../../hooks/useSentimentValue';
import { useFeedsVideoData } from '@op/hooks/data/video';
import useLanguage from '@op/hooks/useLanguage';
import { getCountryFlag } from '@home/_config/countries';

/**
 * studio 页面使用该组件
 * @param param0
 * @returns
 */
export default function FigureCard({
  size = 'normal',
  item,
  wholeGameInfo,
  language = 'origin',
  navigatePage,
  buriedBtnPointId = '',
  loading,
  updateSentiment,
  direction = 'row',
  game,
  showGame = false
}: {
  size: string;
  item: any;
  wholeGameInfo?: any;
  language: LanguageType;
  navigatePage?: Function;
  buriedBtnPointId?: string;
  loading?: boolean;
  updateSentiment?: any;
  direction?: 'row' | 'column';
  game?: any;
  showGame?: boolean;
}) {
  const className =
    size === 'small' ? 'dbo-figure-card --small' : 'dbo-figure-card';
  const { realSentiment: sentimentIcon, Sentiment_Update } = useSentimentValue({
    sentiment: item.sentiment_rating,
    updateSentiment,
  });
  const { formatMessage } = useLanguage();

  const { videoDuration, videoContent, videoImage, openVideoDetailPage, videoDefaultImage } =
    useFeedsVideoData({ data: item, language });

  const openContentPage = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    event.preventDefault();
    openVideoDetailPage();
    buriedBtnPoint(buriedBtnPointId, item.comment_uin);
  };

  const languageAndTimeElement = (
    <>
      <div className="dbo-figure-card-subinfo">
        {(size === 'large' && item?.aigc === 1) && <AIGeneratedTag />}
        {
          item?.author_country && (
            <span className="dbo-figure-card-country">
              <img src={getCountryFlag(item?.author_country)} className='dbc-region-select-item-icon  ' />
            </span>
          )
        }
        <span className="dbo-figure-card-country">
          {transLanguage(item.language)}
        </span>
        <span className="dbo-figure-card-time">
          {moment(item.comment_time).format('YYYY-MM-DD HH:mm')}
        </span>
      </div>
      {
        direction === 'column' && game && (
          <div className="dbo-zone-game-badge">
            <RenderImg
              coverImage={game?.cover}
              className="dbo-zone-game-badge__icon"
            />
            <span className="dbo-zone-game-badge__name">
              {game?.name}
            </span>
          </div>
        )
      }
    </>
  );

  return (
    <a
      href={item.content_url}
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      <div
        className={className}
        onClick={(e) => {
          navigatePage?.(e);
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <div className={`dbo-figure-card-infobox ${direction === 'column' && 'dbo-figure-card-infobox-column'}`}>
          <div className="dbo-figure-card-hd">
            <div className="dbo-figure-card-hd-title">
              <ChannelLabel
                className="dbo-figure-card-icon"
                channel_name={item.channel_name}
                showText={false}
              />
              <div className="dbo-figure-card-title">{item.reviewer}</div>
              <Bubble
                closeOnScroll
                dark
                content={formatMessage({ id: 'Go to original post' })}
                overlayClassName="dbo-figure-card-bubble"
              >
                <span
                  className="dbo-figure-card-userinfo-share"
                  onClick={(event) => {
                    openContentPage(event);
                  }}
                >
                  <SvgIcon type="other-share-icon" />
                </span>
              </Bubble>
            </div>
            {direction === 'row' && !showGame && languageAndTimeElement}
            {direction === 'row' && showGame && game && (
              <div className="dbo-zone-game-badge">
                <RenderImg
                  coverImage={game?.cover}
                  className="dbo-zone-game-badge__icon"
                />
                <span className="dbo-zone-game-badge__name">
                  {game?.name}
                </span>
              </div>
            )}
          </div>
          {direction === 'row' && showGame && languageAndTimeElement}
          {direction === 'column' && languageAndTimeElement}
          <div className="dbo-figure-card-bd">
            <div className="dbo-figure-card-des">
              <Bubble
                closeOnScroll
                dark
                content={videoContent}
                overlayClassName="dbo-figure-card-bubble"
              >
                {videoContent}
              </Bubble>
            </div>
            {size === 'small' && (
              <div className="dbo-figure-card-cover">
                <RenderImg
                  className="dbo-accounts-post-cover"
                  defaultImage={videoDefaultImage}
                  coverImage={videoImage}
                  aigc={item?.aigc === 1}
                // onClick={openVideoPage}
                />
                {videoDuration && (
                  <div className="dbo-figure-card-playnum">
                    <span>{videoDuration}</span>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="dbo-figure-card-ft">
            {size === 'large' && !Sentiment_Update && (
              <div className="dbo-figure-card-numbox --sentiment">
                {loading ? (
                  <Icon type={'loading'} className="dbo-title-flex-icon" />
                ) : (
                  <SvgIcon
                    className="dbo-figure-card-numbox-icon"
                    type={sentimentIconMap[sentimentIcon]}
                  />
                )}
              </div>
            )}

            <div className="dbo-figure-card-numbox">
              <span className="dbo-figure-card-num">
                {reviewsMaxZeroFormat(item.view)}
              </span>
              <span className="dbo-figure-card-numtit">
                {formatMessage({ id: 'Views' })}
              </span>
            </div>
            <div className="dbo-figure-card-numbox">
              <span className="dbo-figure-card-num">
                {reviewsMaxZeroFormat(item.engagement)}
              </span>
              <span className="dbo-figure-card-numtit">
                {formatMessage({ id: 'Engagement' })}
              </span>
            </div>
            <div className="dbo-figure-card-numbox">
              <span className="dbo-figure-card-num">
                {reviewsMaxZeroFormat(item.subscribe)}
              </span>
              <span className="dbo-figure-card-numtit">
                {formatMessage({ id: 'Followers' })}
              </span>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}
